/**
 * Progress Bar Animator for Cart Drawer
 * Animates shipping progress bar smoothly on cart updates
 */

class ProgressBarAnimator {
  constructor() {
    this.previousProgress = 0;
    this.init();
  }

  init() {
    // Initial animation on page load
    this.waitForElement('.bar_percentage-bar', () => {
      this.animateBar(true);
    });

    // Watch for cart drawer updates
    this.observeCartDrawer();
    
    // Listen for custom cart update events
    document.addEventListener('cart:updated', () => {
      setTimeout(() => this.animateBar(), 100);
    });
  }

  /**
   * Wait for element to exist in DOM
   */
  waitForElement(selector, callback, timeout = 5000) {
    const startTime = Date.now();
    
    const checkExist = setInterval(() => {
      const element = document.querySelector(selector);
      
      if (element) {
        clearInterval(checkExist);
        callback(element);
      } else if (Date.now() - startTime > timeout) {
        clearInterval(checkExist);
      }
    }, 100);
  }

  /**
   * Observe cart drawer for DOM changes
   */
  observeCartDrawer() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        // Check if progress bar was added/updated
        if (mutation.addedNodes.length > 0) {
          const hasProgressBar = Array.from(mutation.addedNodes).some(node => {
            if (node.nodeType === 1) { // Element node
              return node.classList?.contains('bar_percentage-bar') || 
                     node.querySelector?.('.bar_percentage-bar');
            }
            return false;
          });
          
          if (hasProgressBar) {
            // Small delay to ensure DOM is ready
            this.animateBar();
            break;
          }
        }
      }
    });

    // Observe the cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }

    // Also observe drawer inner
    const drawerInner = document.querySelector('.drawer__inner');
    if (drawerInner) {
      observer.observe(drawerInner, {
        childList: true,
        subtree: true
      });
    }
  }

  /**
   * Animate the progress bar
   */
/**
   * Animate the progress bar
   */
  animateBar(isInitial = false) {
    const bar = document.querySelector('.bar_percentage-bar');
    if (!bar) return;

    const targetProgress = parseFloat(bar.getAttribute('data-progress')) || 0;
    
    // Użyj 'this.previousProgress' jako punktu startowego,
    // chyba że jest to pierwsze ładowanie (isInitial).
    const startProgress = isInitial ? 0 : this.previousProgress;

    // 1. Ustaw pozycję startową BEZ animacji
    bar.style.transition = 'none';
    bar.style.width = startProgress + '%';

    // 2. Wymuś odświeżenie DOM (ważne!)
    void bar.offsetWidth;

    // 3. Włącz ponownie animację
    bar.style.transition = ''; // Użyje domyślnej z CSS

    // 4. Uruchom animację do wartości docelowej
    requestAnimationFrame(() => {
      bar.style.width = targetProgress + '%';
      
      // Zapisz nową pozycję jako "poprzednią" dla następnego razu
      this.previousProgress = targetProgress;
    });

    // Animuj resztę (wiadomość i etykiety)
    this.animateMessage();
    this.animateLabels(targetProgress);
  }

  /**
   * Animate message fade
   */
  animateMessage(progress) {
  const message = document.querySelector('.shipping-message_full-bag');
  if (!message) return;

  if (progress >= 100) {
    // Tylko przy darmowej wysyłce – świętuj!
    message.style.opacity = '1';
    setTimeout(() => {
      message.style.transition = 'opacity 0.4s ease';
      message.style.opacity = '0.6';
    }, 100);
  }
}

/**
 * Animate labels hiding when qualified
 */
animateLabels(progress) {
  const labels = document.querySelector('.bar_labels');
  if (!labels) return;

  // Zapisz aktualny stan widoczności
  const isCurrentlyHidden = labels.classList.contains('hide-labels');
  
  if (progress >= 100) {
    // Jeśli etykiety nie są jeszcze ukryte, ukryj je z animacją
    if (!isCurrentlyHidden) {
      labels.style.opacity = '0';
      setTimeout(() => {
        labels.classList.add('hide-labels');
      }, 400);
    }
  } else {
    // Jeśli etykiety są ukryte, pokaż je z animacją
    if (isCurrentlyHidden) {
      labels.classList.remove('hide-labels');
      // Wymuś reflow przed animacją
      void labels.offsetHeight;
      labels.style.opacity = '0.8';
    }
  }
}
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProgressBarAnimator();
  });
} else {
  new ProgressBarAnimator();
}

// Also re-initialize when Shopify section is rendered
document.addEventListener('shopify:section:load', () => {
  new ProgressBarAnimator();
});